import Axios from "@/helpers/axios";

export default {
    DEL(context,data){
        return Axios.post(`/favorites/del`, {
            id: data.sub,
            car_id: data.car_id,
        })
    },
    ADD(context,data){
        return Axios.post(`/favorites/add`, data)
    }
}